import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { tailwindConfig } from 'tailwind-config';

import { ROUTE_PATHS } from 'shared/consts/routes';
import { useTypedSelector } from 'store';

import { DSCoverProjects } from './DSCoverProjects';

import { CreateNewProject } from '../CreateNewProject/CreateNewProject';

import { ColumnChartIcon } from 'assets/icons';

const DSCoverSideBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isSidebarOpened = useTypedSelector(store => store.ui.isSidebarOpened);
  const isActive = useMemo(
    () => pathname === ROUTE_PATHS.dsCover || pathname.startsWith(`${ROUTE_PATHS.dsCover}/`),
    [pathname],
  );

  return (
    <>
      <button
        aria-label="DS Cover"
        className={cn('mm-sidebar__menu__item', { _active: isActive })}
        data-testid="ds-cover-nav"
        type="button"
        onClick={() => navigate(ROUTE_PATHS.dsCover)}
      >
        <div className="mm-sidebar__menu__item__left">
          <div className="mm-sidebar__menu__item__icon">
            <ColumnChartIcon color={isActive ? tailwindConfig.theme.colors.primary : undefined} />
          </div>
          <AnimatePresence>
            {isSidebarOpened && (
              <motion.span
                className="mm-sidebar__menu__item__text"
                exit={{ opacity: 0, width: 0 }}
                transition={{ duration: isSidebarOpened ? 0.25 : 0 }}
              >
                DS Cover
              </motion.span>
            )}
          </AnimatePresence>
        </div>
      </button>
      {isActive && isSidebarOpened && (
        <>
          <DSCoverProjects />
          <CreateNewProject defaultNotes="ds-cover" stayOnPage />
        </>
      )}
    </>
  );
};

export { DSCoverSideBar };
